import React from "react";

/**
 * CIDES Invest & Trade Ltd — SVG logo
 * Vectorised replica of the historical mark: tilted globe with orbital
 * swoosh + "CIDES" wordmark + "INVEST & TRADE LTD." tagline. Crisp at any
 * size, dark-theme friendly (transparent background).
 */
export const CidesLogo = ({ className = "", height = 40, variant = "full", ...props }) => {
  // "full" = globe + wordmark + tagline
  // "mark" = globe icon only
  //
  // Text is anchored on a shared central axis (textAnchor="middle" at
  // x = TEXT_CENTER) so the "INVEST & TRADE LTD." tagline is perfectly
  // centred underneath the "CIDES" wordmark.
  const width = variant === "mark" ? height * 1.0 : height * 3.3;
  const viewBox = variant === "mark" ? "0 0 100 100" : "0 0 330 100";
  const TEXT_CENTER = 210;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      width={width}
      height={height}
      className={className}
      role="img"
      aria-label="CIDES Invest & Trade Ltd"
      {...props}
    >
      {/* Globe icon */}
      <g transform="translate(6,10)">
        <g
          transform="rotate(-18 40 40)"
          fill="none"
          stroke="#94a3b8"
          strokeWidth="2"
          strokeLinecap="round"
        >
          {/* Outer sphere (vertical ellipse) */}
          <ellipse cx="40" cy="40" rx="30" ry="34" />
          {/* Equator */}
          <ellipse cx="40" cy="40" rx="30" ry="10" />
          {/* Inner meridians */}
          <ellipse cx="40" cy="40" rx="18" ry="34" />
          <ellipse cx="40" cy="40" rx="6" ry="34" />
          {/* Latitudes */}
          <ellipse cx="40" cy="40" rx="30" ry="22" opacity="0.9" />
        </g>

        {/* Orbital swoosh */}
        <path
          d="M6 56 Q40 8 74 34 L70 30 M74 34 L68 38"
          fill="none"
          stroke="#94a3b8"
          strokeWidth="3.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* Orbit dot */}
        <circle cx="66" cy="30" r="3" fill="#94a3b8" />
      </g>

      {variant === "full" && (
        <g>
          {/* Wordmark */}
          <text
            x={TEXT_CENTER}
            y="60"
            textAnchor="middle"
            fontFamily="Outfit, Arial, sans-serif"
            fontWeight="800"
            fontSize="62"
            letterSpacing="-1"
            fill="#0089C8"
          >
            CIDES
          </text>
          {/* Tagline — same textAnchor middle at same x so it sits centred under CIDES */}
          <text
            x={TEXT_CENTER}
            y="86"
            textAnchor="middle"
            fontFamily="Outfit, Arial, sans-serif"
            fontWeight="600"
            fontSize="18"
            letterSpacing="2.4"
            fill="#0089C8"
          >
            INVEST &amp; TRADE LTD.
          </text>
        </g>
      )}
    </svg>
  );
};

export default CidesLogo;
